import React from 'react';
import Alert from 'react-s-alert';
import { CompanyForm } from '../CompanyForm';
import { I18nUtils } from '../../../../../i18n/I18nUtils';
import { CompanyDetailTask } from './company-detail/CompanyDetailTask';
import { CompanyDetailRequest } from './company-detail/CompanyDetailRequest';
import { PsCompany } from '../../PsCompany';
import { CompanyFormValues } from '../CompanyFormValues';
import { CompanyUpdateRequest } from './company-update/CompanyUpdateRequest';
import { CompanyUpdateTask } from './company-update/CompanyUpdateTask';
import { connect } from 'react-redux';
import { CurrentUser } from '../../../../shared/model/CurrentUser';
import CardHeader from '../../../../shared/components/card-header/CardHeader';
import Card from '../../../../shared/components/Card';
import CardBody from '../../../../shared/components/CardBody';
import Row from '../../../../shared/components/Row';
import { CompanyDocumentChart } from '../../../../shared/components/stats/CompanyDocumentChart';
import PropTypes from 'prop-types';
import HeaderSearchRefreshFilterOptions from '../../../../shared/components/HeaderSearchRefreshFilterOptions';

class CompanyUpdate extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            company: null,
            loading: true,
            collapsed: props.initialCardState.collapsed,
            companyFormValues: CompanyFormValues.null(),
        };
    }

    componentDidMount() {
        this.getCompany();
    }

    componentDidUpdate(_, prevState) {
        const { saveCardState } = this.props;
        const { collapsed } = this.state;

        if ( prevState.collapsed !== collapsed ) {
            saveCardState({ collapsed });
        }
    }

    render() {
        const { currentUser } = this.props;
        const {
            company,
            loading,
            collapsed,
            companyFormValues,
        } = this.state;

        return (
            <Row>
                <Card loading={loading}>
                    <CardHeader
                        title={I18nUtils.tr('TR_MI_EMPRESA').toUpperCase()}
                        rightOptions={(
                            <HeaderSearchRefreshFilterOptions
                                enableFilter={false}
                                enableSearch={false}
                                enableRefresh={false}
                                cardSearchFilterEnabled={false}
                                collapsed={collapsed}
                                onCollapsed={this.collapse}
                            />
                        )}
                    />
                    {
                        !collapsed && company ? (
                            <CardBody>
                                <CompanyDocumentChart stats={company.stats()}>
                                    <CompanyForm
                                        canWrite={currentUser.isAdmin()}
                                        onSubmit={this.updateCompany}
                                        initialValues={companyFormValues.initialValues()}
                                    />
                                </CompanyDocumentChart>
                            </CardBody>
                        ) : null
                    }
                </Card>
            </Row>
        );
    }

    collapse = () => {
        this.setState((prevState) => ( { collapsed: !prevState.collapsed } ));
    };

    getCompany = () => {
        const { currentUser } = this.props;
        const currentCompany = currentUser.company();
        const request = new CompanyDetailRequest(currentCompany.id);

        new CompanyDetailTask(request)
            .onPreExecution(() => this.setState({ loading: true }))
            .onSuccess((res) => {
                const company = PsCompany.fromAPICompany(res.data);
                const companyFormValues = CompanyFormValues.fromCompany(company);
                this.setState({ company, companyFormValues });
            })
            .onFail((error) => Alert.error(error))
            .onPostExecution(() => this.setState({ loading: false }))
            .execute();
    };

    updateCompany = (values) => {
        const { company } = this.state;
        const request = new CompanyUpdateRequest(values, company);

        new CompanyUpdateTask(request)
            .onSuccess(() => {
                Alert.success(I18nUtils.tr('TR_EMPRESA_EDITADA_CORRECTAMENTE'));
                this.getCompany();
            })
            .onFail((error) => Alert.error(error))
            .execute();
    };
}

const mapStateToProps = (state) => ( { currentUser: CurrentUser.fromReduxState(state) } );

export const CompanyUpdateCard = connect(mapStateToProps)(CompanyUpdate);

CompanyUpdateCard.propTypes = {
    saveCardState: PropTypes.func,
    initialCardState: PropTypes.object,
};

CompanyUpdateCard.defaultProps = {
    saveCardState: () => null,
    initialCardState: {
        collapsed: false,
    },
};



// WEBPACK FOOTER //
// ./src/app/my-company/company/form/update/CompanyUpdateCard.jsx